import { Injectable } from '@angular/core';
import { environment } from './../environments/environment';
import { createFlagsmithInstance } from 'flagsmith';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  current_environment = environment.flagsmithenvID;
  flagSmithInstance = createFlagsmithInstance();

  async initializeFlagSmith() {

    if (!this.flagSmithInstance.initialised) {
      await this.flagSmithInstance.init({
        environmentID: `${environment.flagsmithenvID}`,
      }).catch((error) => {
        console.error('FlagSmith failed to load ', error);
      });
      console.log('********************FEATURE FLAG Initialized ', this.flagSmithInstance.initialised);
    }
  }

  async getFlagValue(flag: string): Promise<boolean> {
    await this.initializeFlagSmith();

    const featureEnabled = this.flagSmithInstance.hasFeature(flag);
    console.log('**********************Feature Flag - ' + flag + ' is ', featureEnabled);

    return featureEnabled;
  }
}
